import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'
import { AutomationRuleInterface } from 'client/store/automationRules/automationRulesReducer'
import {
  ActionSaveApiType,
  ActionSaveType,
} from 'src/editor/shared/types/automation-rules/actions-types'
import { ActionIdType } from 'src/editor/shared/types/automation-rules/actions-types'

export const transformAutomationRulesForApi = (
  automationRules: AutomationRuleInterface[],
) => {
  return {
    rules: automationRules
      .filter(rule => !rule.automationTrigger.preventSaving)
      .map(rule => {
        const { preventSaving: _, ...restAutomationTrigger } =
          rule.automationTrigger
        return {
          ...(rule.id ? { id: rule.id } : {}),
          automationTriggers: [restAutomationTrigger],
          automationActions: rule.automationActions.map(action =>
            transformAutomationRuleActionForApi(action),
          ),
        }
      }),
  }
}

const transformAutomationRuleActionForApi = (action: ActionSaveType) => {
  let cleanedApiAction: ActionSaveApiType
  if (action.created) {
    /**
     * NOTE: if "created" is true, id is fake (used for frontend only)
     * the "created" is used to indicate if the action is new and should be saved
     */
    const { created: _, id: __, ...restAction } = action
    cleanedApiAction = { ...restAction }
  } else {
    cleanedApiAction = action
  }

  switch (cleanedApiAction.type) {
    case AutomationRuleActionsEnum.add_tag:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        tag: cleanedApiAction.tag.id,
      }
    case AutomationRuleActionsEnum.remove_tag:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        tag: cleanedApiAction.tag.id,
      }
    case AutomationRuleActionsEnum.subscribe_to_campaign:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        campaign: cleanedApiAction.campaign.id,
      }
    case AutomationRuleActionsEnum.unsubscribe_from_campaign:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        campaign: cleanedApiAction.campaign.id,
      }
    case AutomationRuleActionsEnum.send_email:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        systemeEmail: cleanedApiAction.systemeEmail.id,
      }
    case AutomationRuleActionsEnum.send_email_to_specific_address:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        emailMessageWithRecipient:
          cleanedApiAction.emailMessageWithRecipient.id,
      }
    case AutomationRuleActionsEnum.enroll_in_course:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        course: cleanedApiAction.course.id,
        courseAccessType: cleanedApiAction.courseAccessType,
      }
    case AutomationRuleActionsEnum.revoke_access_to_course:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        course: cleanedApiAction.course.id,
      }
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        courseBundle: cleanedApiAction.courseBundle.id,
      }
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        courseBundle: cleanedApiAction.courseBundle.id,
        enrollmentAccessType: cleanedApiAction.enrollmentAccessType,
      }
    case AutomationRuleActionsEnum.create_user:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        locale: cleanedApiAction.locale,
      }
    case AutomationRuleActionsEnum.send_webhook:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        webhookUrl: cleanedApiAction.webhookUrl,
      }
    case AutomationRuleActionsEnum.grant_access_to_community:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        community: cleanedApiAction.community?.id,
      }
    case AutomationRuleActionsEnum.revoke_access_to_community:
      return {
        ...cleanedApiAction,
        type: cleanedApiAction.type,
        community: cleanedApiAction.community?.id,
      }
  }
}
